module.exports = __webpack_public_path__ + "img/hotsys_1.03c297a3.png";